import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

const FounderSection = () => {
    const { t } = useTranslation();

    return (
        <section id="founder" className="py-24 relative overflow-hidden">
            <div className="container relative z-10">
                <div className="glass p-12 lg:p-20 overflow-hidden relative">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                        
                        {/* 1. Visionary Narrative */}
                        <div className="flex flex-col items-start text-left" data-aos="fade-right">
                            <h2 className="text-4xl lg:text-7xl font-black mb-8 leading-tight uppercase tracking-tighter">
                                <Trans i18nKey="founderSection.title1">Meet the <br /></Trans>
                                <span className="text-primary italic">{t('founderSection.title2')}</span>
                            </h2>
                            <p className="border-l-4 border-primary pl-6 text-text-muted text-lg lg:text-xl mb-10 leading-relaxed italic">
                                "{t('founderSection.quote')}"
                            </p>
                            
                            <div className="flex flex-wrap gap-4 mb-10">
                                <div className="flex items-center gap-3 glass py-2 px-4 border-primary/20 bg-primary/5">
                                    <div className="w-2 h-2 rounded-full bg-primary animate-pulse"></div>
                                    <span className="text-[10px] font-bold uppercase tracking-[0.2em]">{t('founderSection.tag1')}</span>
                                </div>
                                <div className="flex items-center gap-3 glass py-2 px-4 border-primary/20 bg-primary/5">
                                    <div className="w-2 h-2 rounded-full bg-primary animate-pulse"></div>
                                    <span className="text-[10px] font-bold uppercase tracking-[0.2em]">{t('founderSection.tag2')}</span>
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-6 items-center mb-8">
                                <button className="px-10 py-5 bg-primary text-black font-black uppercase tracking-widest hover:scale-105 transition-all shadow-[0_0_30px_rgba(var(--primary-rgb),0.3)]">
                                    {t('founderSection.promiseBtn')}
                                </button>
                                <div className="text-[10px] font-mono opacity-50 tracking-[0.3em]">
                                    {t('founderSection.pipeline')} <span className="text-primary">ZAPTO_NODE_01</span>
                                </div>
                            </div>
                            
                            <a href="#contact" className="text-sm font-bold text-white uppercase tracking-widest border-b-2 border-primary pb-1 hover:text-primary transition-colors">
                                {t('founderSection.cta')} →
                            </a>
                        </div>

                        {/* 2. Decorative Accent (replaces founder image) */}
                        <div className="relative group flex justify-center items-center" data-aos="zoom-in">
                            <div className="relative w-80 h-80 md:w-[450px] md:h-[450px] flex items-center justify-center">
                                {/* Abstract decorative element */}
                                <div className="absolute inset-0 rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/5 via-transparent to-primary/10 backdrop-blur-sm"></div>
                                <div className="absolute inset-4 rounded-2xl border border-primary/10 bg-gradient-to-tl from-primary/5 via-transparent to-transparent"></div>
                                <div className="absolute w-40 h-40 rounded-full bg-primary/10 blur-3xl animate-pulse"></div>
                                
                                {/* Centered initials / monogram */}
                                <div className="relative z-10 text-center">
                                    <div className="text-8xl md:text-9xl font-black text-primary/20 tracking-tighter leading-none">DR</div>
                                </div>

                                {/* Floating Tag */}
                                <div className="absolute -bottom-6 -left-6 md:-left-12 glass p-6 border-primary/50 text-left backdrop-blur-3xl animate-float min-w-[240px]">
                                    <div className="text-[10px] font-bold text-primary mb-1 tracking-[0.4em] uppercase">{t('founderSection.role')}</div>
                                    <div className="text-2xl font-black tracking-tighter">{t('founderSection.name')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default FounderSection;
